import { TColorType, ICapsuleColorProps } from "./type";
export const FONT_SIZE = 14;
export const LIUBAI_PERCENT = 3; 
export const ITEM_MARGIN_BOTTOM = 10;

export const DEFAULT_MUTIPLE_GRADIENTS_COLOR = [
  { start: '#8CE2FF', end: '#56BCE6' },
  { start: '#AD9EFF', end: '#685BC2' },
  { start: '#A6C9FF', end: '#5086F3'},
];

export const DEFAULT_CAPSULE_COLORS_MAP: Record<TColorType, ICapsuleColorProps> = {
  skyBlue: {
    capsule: '#8CE2FF,#56BCE6',
    point: '#5EC4F1',
    text: '#5EC4F1',
  },
  purple: {
    capsule: '#AD9EFF,#685BC2',
    point: '#7F6FF1',
    text: '#7F6FF1',
  },
  lakeBlue: {
    capsule: '#A6C9FF,#5086F3',
    point: '#5EC4F1',
    text: '#5086F3',
  },
  orange: {
    capsule: '#FFAC33',
    point: '#FFAC33',
    text: '#FC8B00',
  },
  black: {
    capsule: '#000000',
    point: '#000000',
    text: '#262832',
  },
  green: {
    capsule: '#69d19c',
    point: '#69d19c',
    text: '#262832',
  },
  red: {
    capsule: '#f17c86',
    point: '#f17c86',
    text: '#262832',
  },
  gray: {
    capsule: '#DDDFE7',
    point: '#DDDFE7',
    text: '#262832',
  }
};
